'use client'

import React from 'react'
import Link from 'next/link'
import { Trans, useTranslation } from 'react-i18next'
import { ButtonLink } from '@kiao-voice/ui-kit'
import { EndCta } from '../../components/site/end-cta'
import { smoothScrollToAnchor } from '../../lib/smooth-scroll'
import { trackSiteLinkClicked } from '@/lib/analytics'

/** 文末 CTA。主鈕回到試轉區（PR-3 才進頁面），次鈕跨頁到方案。 */
export function TranscriptionEndCta() {
  const { t } = useTranslation(['web'])

  return (
    <EndCta
      titleKey="web:transcriptionPage.endCta.title"
      lead={t('web:transcriptionPage.endCta.lead')}
      actions={
        <>
          <ButtonLink
            variant="onlight"
            size="marketing"
            href="#try"
            onClick={(event) => {
              trackSiteLinkClicked('end_cta', '#try')
              smoothScrollToAnchor(event)
            }}
          >
            {t('web:transcriptionPage.endCta.primaryCta')}
          </ButtonLink>
          <ButtonLink
            variant="ondark"
            size="marketing"
            as={Link}
            href="/pricing"
            onClick={() => trackSiteLinkClicked('end_cta', '/pricing')}
          >
            {t('web:transcriptionPage.endCta.secondaryCta')}
          </ButtonLink>
        </>
      }
      meta={
        <Trans
          t={t}
          i18nKey="web:transcriptionPage.endCta.meta"
          components={{
            dictation: (
              <Link
                href="/dictation"
                onClick={() => trackSiteLinkClicked('end_cta', '/dictation')}
                className="border-b border-background/45 text-background transition-colors hover:border-background"
              />
            ),
          }}
        />
      }
    />
  )
}
